export default {
        HOLDING_COMPANY: 'holdingCompany',
        FOUNDATION: 'foundation',
        TECH_STARTUP: 'techStartup',
        OPERATING_COMPANY: 'operatingCompany',
        OTHER: 'other'
};